import { useEffect, useRef } from 'react';

/**
 * Hook per creare un effetto con AbortController integrato
 * Permette di gestire facilmente race conditions e cleanup delle operazioni asincrone
 * 
 * @param {Function} effect - Funzione da eseguire che riceve un AbortSignal
 * @param {Array} deps - Array di dipendenze come per useEffect standard
 */
export function useAbortableEffect(effect: (signal: AbortSignal) => void | (() => void), deps: React.DependencyList = []) {
  useEffect(() => {
    // Crea un nuovo AbortController per ogni esecuzione dell'effetto
    const abortController = new AbortController();
    
    // Memorizza l'eventuale funzione di cleanup restituita dall'effetto
    const cleanup = effect(abortController.signal);
    
    // Gestisce il cleanup quando l'effetto viene ricreato o il componente smontato
    return () => {
      // Prima segnala l'abort
      abortController.abort();
      // Poi esegue il cleanup personalizzato se esiste
      if (typeof cleanup === 'function') {
        cleanup();
      }
    };
  }, deps);
}